module.exports = __webpack_public_path__ + "img/the-platform-logo-w-powered.8243ae51.svg";